import React from 'react';

function DinersIcon() {
  return (
    <svg width="58" height="40" viewBox="0 0 58 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.3259 31.8302H30.6528C37.4068 31.8302 42.7889 26.4719 43 19.8527V19.7477C42.8945 13.0234 37.4068 7.56 30.6528 7.66506H25.7983C19.3608 7.8752 14.2953 13.3386 14.5064 19.8527C14.5064 26.3668 19.783 31.7252 26.3259 31.8302ZM16.6173 19.7476C16.6173 14.2841 21.1552 9.76629 26.6429 9.76629C32.1305 9.76629 36.6684 14.2841 36.6684 19.7476C36.6684 25.211 32.1305 29.7288 26.6429 29.7288C21.1552 29.7288 16.6173 25.211 16.6173 19.7476ZM28.2254 26.4719V13.1285C31.919 14.0741 34.2407 17.7514 33.291 21.4287C32.6578 23.9503 30.7582 25.8415 28.2254 26.4719ZM20.0998 18.0666C19.15 21.7439 21.3662 25.5263 25.0598 26.4719V13.1285C22.6326 13.7589 20.733 15.6501 20.0998 18.0666Z"
        fill="#0079BE"
      />
    </svg>
  );
}

export default DinersIcon;
